module.exports = {
  localeName: 'it-CH',
  momentFormat: 'DD.MM.YYYY'
};
